import React from "react";
import { NewInputText } from "../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import { IconboxReusableComponent } from "../../reusableOnboardingComponent/RestaurantChain/IconboxReusableComponent";
import { AddButtonIconComponent } from "../../../reusableComponents/buttonReusableComponent/ButtonReusableComponent";
import AddIcon from "@material-ui/icons/Add";
import { InputBase, makeStyles, fade } from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import { ReusableOnboardingMapButton } from "../../reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";

const useStyles = makeStyles((theme) => ({
  search: {
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    "&:hover": {
      backgroundColor: fade(theme.palette.common.white, 0.25),
    },
    // marginRight: theme.spacing(2),
    marginLeft: 0,
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      // marginLeft: theme.spacing(3),
      // width: "auto",
    },
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  inputRoot: {
    color: "inherit",
    width: "100%",
    border: "1px solid #BCBCBC",
    borderRadius: "5px",
    padding: theme.spacing(1, 0),
  },
  inputInput: {
    // padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create("width"),
    width: "100%",
    "&::-webkit-input-placeholder": {
      color: "gray !important",
    },
    // [theme.breakpoints.up("md")]: {
    //   width: "20ch",
    // },
  },
}));

const RestaurantChainsListComponent = ({ localProps, state, ...props }) => {
  let restaurant_list = state?.all_restaurant_chains;
  if (state.search !== "") {
    let searchExp = new RegExp(state.search, "i");
    restaurant_list = restaurant_list.filter((restaurant) =>
      searchExp.test(restaurant.title)
    );
  }
  const classes = useStyles();
  return (
    <div className="restaurant_chains_onboarding_main">
      <div className="col-md-6 pl-0">
        <NewInputText
          name="location_code"
          inputType="text"
          onChange={localProps.onChangeHandler}
          onFocusOut={localProps.onFocusOut}
          value={state.location_code}
          labelText="Location Code"
          helpTextDisplay={true}
          helperTextBottom="Enter your Location Code if any"
          controlClass={"outlined-helperText"}
        />
      </div>
      <div className="col-12 restaurant_chains_onboarding_main_section_third">
        <div className={classes.search}>
          <div className={classes.searchIcon}>
            <SearchIcon />
          </div>
          <InputBase
            placeholder="Search below using name or code"
            classes={{
              root: classes.inputRoot,
              input: classes.inputInput,
            }}
            inputProps={{ "aria-label": "Search below using name or code" }}
            value={state.search}
            onChange={localProps.onChangeHandler}
            name="search"
          />
        </div>
        {/* <div className="section_third_two_width mb-4 mb-md-0 mb-lg-0 mb-xl-0">
          <NewInputText
            extraClass="mt-0 mb-0"
            name="search"
            inputType="search"
            onChange={localProps.onChangeHandler}
            value={state.search}
            labelText="Search below using name or code"
            controlClass={"outlined-helperText"}
          />
        </div> */}
        <div className="section_third_one_width">
          <button
            className="add-button-icon-reusable"
            style={{ color: "#EE3A23" }}
            onClick={localProps.onToggleHandler("is_suggest_new_open", true)}
          >
            <div className="mr-2">
              <AddIcon
                style={{
                  fontSize: 26,
                  color: "#fff",
                  backgroundColor: "#EE3A23",
                  borderRadius: 24,
                  marginRight: 5,
                  boxShadow: "4, 4, 10, #0000002F",
                }}
              />
            </div>
            Set Up New
          </button>
          {/* <AddButtonIconComponent
            buttonText="Set Up New"
            onClick={localProps.onToggleHandler("is_suggest_new_open", true)}
            fontIcon="fa fa-plus"
            colorCss="red"
          /> */}
        </div>
      </div>
      <div className="col-12 p-0 restaurant_chains_onboarding_main_divone">
        <div className="f16-700">Select Your Chain</div>
        <div className="f12-400 opacity5 mb-3">
          Select a Chain your food establishment belongs
        </div>
      </div>
      <div className="restaurant_type_onboarding_main">
        <div>
          <div className="cuisine-main restaurant-chain-display-mobile-margin">
            <div
              className={`${
                restaurant_list && restaurant_list.length > 8
                  ? "cuisine-main-padding-border"
                  : ""
              } mobile-border-1px-solid-and-raduis-15px`}
            >
              <div
                id="box-style"
                className="cuisine-main-padding pl-1 column-3"
                // className="mobile-device-chains-cls"
                style={{ display: "flex", flexWrap: "wrap" }}
              >
                {restaurant_list &&
                  restaurant_list.map((restaurant, index) => (
                    <ReusableOnboardingMapButton
                      key={index}
                      classsection={
                        restaurant._id === state.restaurant_chain_id
                          ? "onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type restaurant-chain-icon-box-active"
                          : "onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type"
                      }
                      extraClass={"mr-0"}
                      src={restaurant.icon}
                      title={restaurant.title}
                      onClick={localProps.onToggleHandler(
                        "restaurant_chain_id",
                        restaurant._id
                      )}
                    />
                    // <IconboxReusableComponent
                    //   key={index}
                    //   src={restaurant.icon}
                    //   title={restaurant.title}
                    //   classSection={
                    //     restaurant._id === state.restaurant_chain_id
                    //       ? "restaurant-chain-icon-box restaurant-chain-icon-box-active"
                    //       : "restaurant-chain-icon-box"
                    //   }
                    //   onClick={localProps.onToggleHandler(
                    //     "restaurant_chain_id",
                    //     restaurant._id
                    //   )}
                    // />
                  ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RestaurantChainsListComponent;
